// extracted by mini-css-extract-plugin
module.exports = {"tooltipButton":"TooltipButton_tooltipButton__37eII","maxWidth":"TooltipButton_maxWidth__KUord"};